import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { brivioLogo } from '../../assets/svgs/BrivioLogo.svgs';

import { ApiTypes } from '@/types/server/api.types';
import { handleLogout } from '@/utils/auth.utils';

export const Navbar = ({
	isUserLoggedIn,
	setIsUserLoggedIn,
	userDetails,
	setUserDetails,
}: {
	isUserLoggedIn: boolean;
	setIsUserLoggedIn: (isUserLoggedIn: boolean) => void;
	userDetails: ApiTypes.TGetCandidateDetailsResponse['data'] | null;
	setUserDetails: (
		userDetails: ApiTypes.TGetCandidateDetailsResponse['data'] | null
	) => void;
}) => {
	const navigate = useNavigate();
	const [isLoggingOut, setIsLoggingOut] = useState(false);

	const _handleLogout = async () => {
		setIsLoggingOut(true);
		await handleLogout();
		setIsUserLoggedIn(false);
		setUserDetails(null);
		setIsLoggingOut(false);
	};

	return (
		<nav className="sticky top-0 z-50 bg-white shadow-sm">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
				<div
					className="flex items-center gap-1 cursor-pointer"
					onClick={() => navigate('/')}
				>
					<div className="w-5 h-5 text-blue-500">{brivioLogo()}</div>
					<h1
						className="text-2xl font-semibold text-blue-500 tracking-tight"
						style={{ fontFamily: 'GeneralSansSemiBold, sans-serif' }}
					>
						brivio
					</h1>
				</div>
				{isUserLoggedIn && userDetails ? (
					<button
						className="text-sm text-gray-500 font-normal hover:text-gray-700 transition-colors cursor-pointer"
						onClick={() => {
							if (isLoggingOut) return;
							_handleLogout();
						}}
					>
						{userDetails.email} | Sign out
					</button>
				) : null}
			</div>
		</nav>
	);
};
